export default __webpack_public_path__ + "static/SR France - Halal - Certificat-5ab3c84bffff5f3446d5a138c1eb14b8.pdf";